import { ApiCommodityCommodityMarketingDetailResponse } from '@/api'
import { uniq } from 'vtils'

export function getDisplayPrice(goods: {
  sellPrices?: number[]
  lowestPrice?: number
  price?: number

  isDcd?: boolean
  marketingData?: ApiCommodityCommodityMarketingDetailResponse
}): string {
  let sellPrices = goods.isDcd
    ? goods.marketingData?.integrals?.map(sku => sku.discountPrice)
    : goods.sellPrices?.sort((a, b) => a - b)
  if (sellPrices) {
    sellPrices = uniq(sellPrices)
  }
  return String(
    !sellPrices
      ? goods.lowestPrice ?? goods.price
      : sellPrices.length === 1
      ? sellPrices[0]
      : `${sellPrices[0]}~${sellPrices[sellPrices.length - 1]}`,
  )
}
